import { useCallback } from 'react'

import { createCompany } from '@/features/domain/company'
import { useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'
import { useModalsContext } from '../../../context/ModalsContextProvider'
import { useTexts } from '../hooks/useTexts'
import { resetEditingState } from '@/atoms'
import { useController } from './useController'
import { FormValues } from '../../../types'

export function useOnSubmit() {
  const toast = useNotification()
  const texts = useTexts()
  const { onCompanyAdded } = useModalsContext()
  const dispatch = useAppDispatch()
  const { close } = useController()

  return useCallback(
    async (formValues: FormValues) => {
      try {
        const result = await dispatch(createCompany(formValues.name))

        if (createCompany.rejected.match(result)) {
          throw new Error(result.payload?.message ?? 'Internal error')
        }

        toast.success(texts.toast.success)
        onCompanyAdded?.(result.payload.id)

        resetEditingState()
        close?.()
      } catch (e) {
        toast.error(e.message)
      }
    },
    [toast, close, dispatch, onCompanyAdded, resetEditingState, texts],
  )
}
